import { PaymentMethod } from '@entities/payment'
import { authHelper } from '@entities/user'
import { PaymentDenomination, PaymentPayee } from '@entities/tsp'

interface GetActualServiceForCommisionArgs {
  isSteam: boolean
  isVouchers: boolean
  payee: PaymentPayee
  activeDenomination: PaymentDenomination | null
  paymentMethod: PaymentMethod
}

export const getActualServiceForCommision = ({
  isVouchers,
  payee,
  activeDenomination,
  paymentMethod,
}: GetActualServiceForCommisionArgs) => {
  if (paymentMethod === PaymentMethod.SBP) {
    return payee
  }

  if (paymentMethod === PaymentMethod.MTS_ACCOUNT && !authHelper.isAuthenticated()) {
    return payee
  }

  return !isVouchers ? payee : activeDenomination
}
